import React, { PureComponent } from "react";

import { TTP_API_URL } from "Config";
//import PelletContainer from "./Pellet/PelletContainer";
import TalkContainer from "./Talk/TalkContainer";
import SurveyContainer from "./Survey/SurveyContainer";
import WheretobillContainer from "./Wheretobill/WheretobillContainer";
//import _ from "i18n";

export default class Header extends PureComponent {
  render() {
    const { community } = this.props;

    const { avatarWebPath, avatarUrl } = community;

    const logo = avatarUrl
      ? avatarUrl
      : avatarWebPath
        ? `${TTP_API_URL}'/'${avatarWebPath}`
        : "/img/community-default-logo.png";

    return (
      <div id="new-community-header">
        <div className="body-header grid-x">
          <div className="logo cell small-12 medium-6 large-3">
            <img src={logo} alt={community.name} />
          </div>
          <TalkContainer />
          <SurveyContainer />
          <WheretobillContainer />
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Community/ClientSpace/Header.js